import React, { useState } from 'react';
import { Box, Typography, Paper, TextField, Button, Switch, FormControlLabel, Snackbar, Alert } from '@mui/material';
import { apiFetch } from '../utils/apiFetch';

export default function MoverSettings({ token }) {
  const [password, setPassword] = useState('');
  const [twoFA, setTwoFA] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const handleChangePassword = async () => {
    if (!password || password.length < 6) {
      setSnackbar({ open: true, message: 'Password must be at least 6 characters', severity: 'error' });
      return;
    }
    
    try {
      await apiFetch('/api/settings/password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ newPassword: password })
      });
      setSnackbar({ open: true, message: 'Password changed!', severity: 'success' });
      setPassword('');
    } catch {
      setSnackbar({ open: true, message: 'Failed to change password.', severity: 'error' });
    }
  };

  const handleToggle2FA = async (e) => {
    const enabled = e.target.checked;
    setTwoFA(enabled);
    try {
      await apiFetch('/api/settings/2fa', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ enabled })
      });
      setSnackbar({ open: true, message: `2FA ${enabled ? 'enabled' : 'disabled'}!`, severity: 'success' });
    } catch {
      setSnackbar({ open: true, message: 'Failed to toggle 2FA.', severity: 'error' });
      setTwoFA(!enabled); // Revert on error
    }
  };
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" sx={{ mb: 3, fontWeight: 700 }}>Settings</Typography>
      <Paper sx={{ p: 4, mb: 2 }}>
        <Typography variant="subtitle1">Change Password</Typography>
        <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
          <TextField label="New Password" type="password" value={password} onChange={e => setPassword(e.target.value)} size="small" />
          <Button variant="contained" onClick={handleChangePassword}>Change</Button>
        </Box>
        <FormControlLabel control={<Switch checked={twoFA} onChange={handleToggle2FA} />} label="Enable Two-Factor Authentication (2FA)" />
      </Paper>
      <Snackbar open={snackbar.open} autoHideDuration={2000} onClose={() => setSnackbar(s => ({ ...s, open: false }))} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <Alert severity={snackbar.severity} sx={{ width: '100%' }}>{snackbar.message}</Alert>
      </Snackbar>
    </Box>
  );
}
